import styles from './Portfolio.module.css';
import PortfolioDetail from './PortfolioDetail';

const projectsData = [
    {
        name: 'Weather App',
        icon: 'fa-solid fa-sun',
        url: 'https://weather-site-tau.vercel.app/',
        description: 'Un\'applicazione per visualizzare le previsioni meteo in tempo reale.'
    },
    {
        name: 'Rock Paper Scissors',
        icon: 'fa-solid fa-hand-scissors',
        url: 'https://rock-paper-scissor-rosy-iota.vercel.app/',
        description: 'Il classico gioco della morra cinese con un\'interfaccia interattiva.'
    },
    {
        name: 'Meme Generator',
        icon: 'fa-solid fa-square-plus',
        url: 'https://meme-generator-flame-nu.vercel.app/',
        description: 'Un semplice tool per creare meme personalizzati partendo da template famosi.'
    },
    {
        name: 'Google API',
        icon: 'fa-brands fa-google',
        url: 'https://store-google-api.vercel.app/',
        description: 'Progetto di integrazione con le API di Google per la ricerca di libri.'
    },
    {
        name: 'Nasa API',
        icon: 'fa-solid fa-rocket',
        url: 'https://nasa-api-sigma-ten.vercel.app/',
        description: 'Esplora le immagini astronomiche del giorno fornite dalle API della NASA.'
    },
    {
        name: 'ToDo List',
        icon: 'fa-solid fa-list',
        url: 'https://to-do-list-orpin-gamma.vercel.app/',
        description: 'Una classica applicazione per gestire le proprie attività quotidiane.'
    },
    {
        name: 'Biomanage Srl',
        icon: 'fa-solid fa-leaf',
        url: 'https://biomanage.it/',
        description: `Sito web istituzionale per Biomanage Srl, azienda specializzata in gestione integrata e completa per gli impianti Biogas e Biometano.`
    }
];

export default function Portfolio() {
    return (
        // La section esterna rimane la stessa
        <section className={styles.portfolioSection}>
            <h2>PORTFOLIO</h2>
            {/* 2. Ho sostituito lo slider con un contenitore a griglia. */}
            <div className={styles.portfolioGrid}>
                {/* 3. Ora mappiamo l'array di dati per creare dinamicamente ogni progetto. */}
                {projectsData.map((project) => (
                    <PortfolioDetail 
                        key={project.name}
                        name={project.name}
                        icon={project.icon}
                        url={project.url}
                        description={project.description}
                    />
                ))}
            </div>
        </section>
    )
}
